import React from 'react';
import arrow1 from '../Images/Group 2069/Group 2069.png';

import StrtImg from '../Images/Strategy/Group 2199.png';
// import GraphicImg from '../Images/GraphicDesign/Group.png';
// import WebImg from '../Images/Website/Group.png';
// import MotionImg from '../Images/Motion/Group.png';
// import SocialImg from '../Images/Social/Group.png';
// import AppImg from '../Images/App/Group.png';
// import SoundImg from '../Images/Sound/Group.png';
// import AiImg from '../Images/AI/Group.png';

const strategyData = [
  {
    title: "Strategy",
    // image: StrtImg,
    heading: "Ideation-Driven. Research-Backed. Execution-Focused.",
    text: "At Red Fibre, strategy isn’t a one-size-fits-all solution — it’s a dynamic, data-informed blueprint crafted uniquely for every brand. Our strategic framework blends creativity with analytical precision, ensuring your brand not only looks good but performs brilliantly."
  },
  {
    title: "Graphic Design",
    // image: GraphicImg,
    heading: "Visual Identity that Captivates and Converts.",
    text: "From logos to packaging, we design with intent. Our graphic solutions combine storytelling with design systems that enhance brand memorability and market impact."
  },
  {
    title: "Website Creation",
    // image: WebImg,
    heading: "Responsive. Intuitive. Purpose-Driven.",
    text: "We craft websites that go beyond just being pretty. Every pixel and function serves your brand’s goals — built for speed, scalability, and seamless experiences across devices."
  },
  {
    title: "Motion & Video",
    // image: MotionImg,
    heading: "Narratives in Motion, Designed to Engage.",
    text: "We bring stories to life through animation, explainer videos, and brand films. Our motion work transforms static messages into immersive visual journeys."
  },
  {
    title: "Social Media",
    // image: SocialImg,
    heading: "Buzz-Worthy Content. Platform-Perfect Presence.",
    text: "We translate your brand’s voice into impactful posts, reels, and campaigns that build community, drive engagement, and spark conversations in the digital crowd."
  },
  {
    title: "App Creation",
    // image: AppImg,
    heading: "Scalable Tech, Seamless Design.",
    text: "From ideation to deployment, we develop user-first mobile and web apps that blend functionality with frictionless UX, turning ideas into usable platforms."
  },
  {
    title: "Sound Design",
    // image: SoundImg,
    heading: "Audio Branding for Deeper Resonance.",
    text: "We create sonic identities that add dimension to your brand — from custom jingles to immersive soundscapes for apps, videos, and events."
  },
  {
    title: "AI, AR & VR",
    // image: AiImg,
    heading: "Future-Ready Solutions that Interact, Learn & Inspire.",
    text: "We integrate intelligent and immersive technologies into your brand experience — with AI-generated content, augmented reality campaigns, and virtual environments that spark delight."
  },
];

function StrtMain1({ service }) {
  const filteredData = service
    ? strategyData.filter((item) => item.title === service)
    : strategyData;

  return (
    <>
      {filteredData.map((item, index) => (
        <div className="StrtHead" key={index}>
          <img src={item.image} alt={item.title} className='StrtImg' />
          <h2>{item.heading}</h2>
          <p>{item.text}</p>
          <div className="lm-btn">
            <button className='lm'>
              Service Features
              <div className="arrows">
                <img src={arrow1} alt="arrow1" className='arrow1' />
                <img src={arrow1} alt="arrow1" className='arrow2' />
              </div>
            </button>
            <div className="btn-r"></div>
            <div className="btn-w"></div>
          </div>
        </div>
      ))}
    </>
  );
}

export default StrtMain1;
